import React from 'react';
import CuiButton from '../CuiComponents/Button';
import './AppHeader.scss';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import { navigate } from '../../redux/actions/CourseActions';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import useXapi from '../../Hooks/useXapi';
import CmsTools from '../CmsTools/CmsTools';
import ReactModal from 'react-modal';
import { actionsToShowModal } from '../../redux/actions/AppHeaderModalActions';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

const AppHeader = () => {
  const { xApiEvent } = useXapi();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    learningPathJson,
    courseTitle,
    currentStep,
    isNavVisible,
    searchedWords
  } = useSelector(
    state => ({
      currentStep: state.CourseState.currentStep,
      learningPathJson: state.CourseState.learningPathJson,
      courseTitle: state.CourseState.courseTitle,
      isNavVisible: state.SideNavState.isNavVisible,
      searchedWords: state.SearchState.searchedWords
    }),
    shallowEqual
  );

  ReactModal.setAppElement('#root');
  return (
    <HelmetProvider>
      <Helmet>
        <title>
          {courseTitle === currentStep.name
            ? courseTitle
            : `${courseTitle} -${currentStep.name}`}
        </title>
      </Helmet>
      <header className={`app-header header ${isNavVisible && 'nav-visible'}`}>
        <button
          className="nav-toggle"
          aria-label={t('AppHeader.toggleNavVisibility')}
          onClick={() => {
            xApiEvent(
              `Side Navigation ${isNavVisible ? 'Closed' : 'Opened'}`,
              window.location.href
            );
            dispatch({ type: 'TOGGLE_SIDE_NAV' });
          }}
        >
          <span className=" icon-list-menu icon-small" />
        </button>
        <div className="header-bar container-fluid">
          <a
            href={`/${learningPathJson['@id']}`}
            className="header-bar__logo"
            onClick={e => {
              e.preventDefault();
              setTimeout(() => {
                dispatch(navigate({ li: learningPathJson['@id'] }));
                xApiEvent('Logo Clicked', window.location.href);
              });
            }}
          >
            <span className="icon-cisco" aria-label={t('AppHeader.logo')} />
          </a>
          <div className="header-bar__main">
            <div className="header-heading">
              <CmsTools
                id={learningPathJson.title_assetid}
                type="assets"
                subtype="text"
              />
              <h1 className="page-title">{courseTitle}</h1>
              {learningPathJson.version && (
                <span className="version-label label label--tiny label--ltgray">
                  v{learningPathJson.version.replace('00', '0')}
                </span>
              )}
            </div>
          </div>
          <div className="header-toolbar">
            <Tooltip
              title={t('AppHeader.recentlyViewed')}
              position="bottom"
              trigger="mouseenter"
              animation="perspective"
              size="big"
              className="tooltip"
              touchHold="true"
            >
              <CuiButton
                icon="recent-apps"
                size="large"
                onClick={() => {
                  dispatch(actionsToShowModal('SHOW_RV'));
                }}
                aria-label={t('AppHeader.recentlyViewed')}
              />
            </Tooltip>
            <Tooltip
              title={t('AppHeader.bookmarks')}
              position="bottom"
              trigger="mouseenter"
              animation="perspective"
              size="big"
              className="tooltip"
              touchHold="true"
            >
              <CuiButton
                icon="bookmark"
                size="large"
                aria-label={t('AppHeader.bookmarks')}
                onClick={() => dispatch(actionsToShowModal('SHOW_BOOKMARKS'))}
              />
            </Tooltip>
            <Tooltip
              title={t('AppHeader.courseIndex')}
              position="bottom"
              trigger="mouseenter"
              animation="perspective"
              size="big"
              className="tooltip"
              touchHold="true"
            >
              <CuiButton
                icon="list-view"
                size="large"
                aria-label={t('AppHeader.courseIndex')}
                onClick={() => dispatch(actionsToShowModal('SHOW_INDEX'))}
              />
            </Tooltip>

            <Tooltip
              title={t('AppHeader.search')}
              position="bottom"
              trigger="mouseenter"
              animation="perspective"
              size="big"
              className="tooltip"
              touchHold="true"
            >
              <CuiButton
                icon="search"
                size="large"
                aria-label={t('AppHeader.search')}
                onClick={() => dispatch(actionsToShowModal('SHOW_SEARCH'))}
              />
            </Tooltip>
            <Tooltip
              title={t('AppHeader.language')}
              position="bottom"
              trigger="mouseenter"
              animation="perspective"
              size="big"
              className="tooltip"
              touchHold="true"
            >
              <CuiButton
                icon="language"
                size="large"
                aria-label={t('AppHeader.language')}
                onClick={() => dispatch(actionsToShowModal('SHOW_LANGUAGES'))}
              />
            </Tooltip>
          </div>
        </div>
        {searchedWords.length > 0 && (
          <button
            className="clear-words btn btn--white btn--small"
            onClick={() =>
              dispatch({ type: 'SEARCH_WORDS', searchedWords: [] })
            }
          >
            {t('AppHeader.clearWordHighlights')}
          </button>
        )}
      </header>
    </HelmetProvider>
  );
};

export default AppHeader;
